
import AppSidebar from '@/components/App/AppSidebar.vue';
import AppNavbar from '@/components/App/AppNavbar.vue';
import { defineComponent } from 'vue';
import { Unsubscribe } from 'firebase/auth';
export default defineComponent({
    name: 'MainLayout',
    props: {
        loadingState: {
            type: Boolean,
            required: true,
            default: true
        }
    },
    data: () => ({
        listener: null as unknown as {
            contactsListener: Unsubscribe,
            messagesListeners: Unsubscribe[]
        }
    }),
    components: {
        AppSidebar, AppNavbar
    },
    computed: {
        username() {
           return this.$store.getters['auth/getUser'].displayName
        },
        userContacts() {
            return this.$store.getters['contacts/getContacts'].length
        }
    }
})
